import React from 'react'
import { get } from 'lodash'
import { useSelector, useDispatch } from "react-redux"
import { Stack, TablePagination } from '@mui/material'
import { updateListPagination } from '../orm/orm_list_actions'

const DEFAULT_ROWS_PER_PAGE = 20

export default function Pagination({ item_list }) {
  const dispatch = useDispatch()
  const listPagination = useSelector(() => item_list.getPagination())

  const handleChangePage = (event, newPage) => {
    dispatch(updateListPagination(item_list.listKey, {page: newPage+1}))
    dispatch(item_list.invalidateList())
    dispatch(item_list.fetchListIfNeeded())
  }

  const handleChangeRowsPerPage = (event) => {
    dispatch(updateListPagination(item_list.listKey, {items_per_page:parseInt(event.target.value, 10), page: 1}))
    dispatch(item_list.invalidateList())
    dispatch(item_list.fetchListIfNeeded())
  }

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      spacing={2}
      sx={{
        borderTop: '1px solid #e6eef7',
        background: '#fff',
        padding: 0,
        flexShrink: 0,
        borderRadius: '0 0 14px 14px',
        margin: 0,
      }}
    >
      <TablePagination
        component="div"
        count={get(listPagination, 'num_items', 0)}
        page={get(listPagination, 'current_page', 1) - 1}
        onPageChange={handleChangePage}
        rowsPerPage={get(listPagination, 'items_per_page', DEFAULT_ROWS_PER_PAGE)}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[20, 50, 100]}
        sx={{
          fontSize: 12.5,
          color: '#7a7a76',
          '& .MuiToolbar-root': {
            minHeight: 44,
            paddingRight: '10px',
          },
          '& .MuiTablePagination-selectLabel': {
            fontSize: 12.5,
            color: '#7a7a76',
          },
          '& .MuiTablePagination-displayedRows': {
            fontSize: 12.5,
            color: '#7a7a76',
            fontVariantNumeric: 'tabular-nums',
          },
          '& .MuiTablePagination-select': {
            fontSize: 12,
            fontWeight: 600,
            color: '#0b3556',
            borderRadius: '8px',
            border: '1px solid #d6e2ef',
            '&:hover': {
              borderColor: '#3a86d8',
            },
            '&:focus': {
              borderRadius: '8px',
              borderColor: '#3a86d8',
              boxShadow: '0 0 0 3px #e7f0fa',
            },
          },
          '& .MuiTablePagination-actions button': {
            color: '#7a7a76',
            borderRadius: '6px',
            width: 28,
            height: 28,
            '&:hover': {
              background: '#e7f0fa',
              color: '#0b3556',
            },
            '&.Mui-disabled': {
              opacity: 0.35,
            },
          },
        }}
      />
    </Stack>
  )
}
